import {
  LAKEMANAGELIST,
  LAKEMANAGEALLLIST
} from 'actions/lakeManage';
import {reducerPackage} from "../../utils";
//湖泊
export const lakeManageList = reducerPackage(LAKEMANAGELIST);
export const lakeManageAllList = reducerPackage(LAKEMANAGEALLLIST);

